import { connect } from "react-redux";

import DragDropMaterial from "./DragDropMaterial";

import { showModal } from "~/store/ducks/domain/ui/modal";
import { selectIsEditMode } from "~/store/ducks/application/materials/isEditMode";
import { selectDisplayedPages } from "~/store/selectors/page";

function mapStateToProps(state) {
  return {
    activePages: selectDisplayedPages(state),
    isEditMode: selectIsEditMode(state)
  };
}

const mapDispatchToProps = {
  showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(DragDropMaterial);
